import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/img/icon/printer.svg'


const _hoisted_1 = { class: "flex w-full justify-end items-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  class: "mx-auto",
  alt: "qr-code-success"
}
const _hoisted_4 = { class: "my-5" }
const _hoisted_5 = { class: "text-xl font-normal" }
const _hoisted_6 = { class: "text-sm font-normal" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-field w-full" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "sovenirCode",
  class: "text-body2"
}, "Jenis Souvenir", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field w-full" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "sovenirCode",
  class: "text-body2"
}, "Alamat Pengiriman (opsional)", -1)
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "flex items-center justify-between text-center mt-5" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("p", {
    class: "text-base font-bold",
    style: {"color":"black"}
  }, "Scan Ulang")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "print",
    width: "24",
    height: "24"
  }),
  /*#__PURE__*/_createVNode("p", {
    class: "ml-3 text-base font-bold",
    style: {"color":"black"}
  }, "Print Bukti Redeem ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: $setup.showDialog,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ($setup.showDialog = $event)),
    class: "dialog-voucher relative",
    modal: true,
    dismissableMask: true
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideDialogPrintRedeem()))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        ($props.voucherData.Filename)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: `${$setup.baseUrl}${$props.voucherData.Filename}`,
              class: "rounded-lg w-full",
              alt: "qr-code-success"
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3)),
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString($props.voucherData.Nama), 1),
          _createVNode("p", _hoisted_6, _toDisplayString($props.voucherData.Keterangan), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "sovenirCode",
              class: "input-primary mt-1",
              type: "text",
              modelValue: $setup.dataForm.jenis,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.dataForm.jenis = $event))
            }, null, 8, ["modelValue"]),
            (($setup.v$.jenis.$invalid && $setup.submitted) || $setup.v$.jenis.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString($setup.v$.jenis.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Textarea, {
              id: "descriptionId",
              class: "w-full input-primary mt-1",
              modelValue: $setup.dataForm.alamat,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.dataForm.alamat = $event))
            }, null, 8, ["modelValue"]),
            (($setup.v$.alamat.$invalid && $setup.submitted) || $setup.v$.alamat.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString($setup.v$.alamat.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            class: "p-button-outlined-orange rescan p-button-sm rounded-md",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.rescan()), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "p-button-outlined-orange p-button-sm rounded-md",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.submitData(!$setup.v$.$invalid)), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}